import { render, staticRenderFns } from "./AuthorisedSignature.vue?vue&type=template&id=1df366a2&"
import script from "./AuthorisedSignature.vue?vue&type=script&lang=js&"
export * from "./AuthorisedSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports